import styled, { css } from 'styled-components';
export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  padding: 12px 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  svg {
    width: 24px;
    height: 24px;
    color: #404040;
  }
`;

export const TextContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const MainText = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1A1A1A;
  line-height: 20px;
  word-break: break-all;
`;

export const SecondaryText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #808080;
  line-height: 16px;
`;

export const KoinsValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1A1A1A;
  white-space: nowrap;
  flex-shrink: 0;
`;
export const TextCard = styled.span<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
}>`
  ${({ fontWeight, color, fontSize }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
  `}
`;
export const TextAside = styled.div<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
}>`
  ${({ fontWeight, color, fontSize }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
  `}
`;
export const InputNumberWrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid #d8d8d8;
    border-radius: 0.8rem;
    padding: 1rem 0.8rem;
    background: white;
  `}
`;

export const NumberInput = styled.input`
  ${({ theme }) => css`
    border: none;
    outline: none;
    text-align: center;
    font-size: ${theme.font.sizes.medium || '16px'};
    font-weight: 500;
    width: 60px;
    background: transparent;

    /* Remove setas do input number */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
    }
  `}
`;

export const NumberButton = styled.button<{ disabled?: boolean }>`
  ${({ disabled }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    opacity: ${disabled ? 0.5 : 1};
    padding: 0.25rem;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover:not(:disabled) {
      background: #f5f5f5;
    }

    &:disabled {
      pointer-events: none;
    }
  `}
`;

